import { render, staticRenderFns } from "./nav-box.vue?vue&type=template&id=69f9e1d8&scoped=true&"
import script from "./nav-box.vue?vue&type=script&lang=js&"
export * from "./nav-box.vue?vue&type=script&lang=js&"
import style0 from "./nav-box.vue?vue&type=style&index=0&id=69f9e1d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f9e1d8",
  null
  
)

export default component.exports